import { AppointmentType } from '../../../graphql';

export const getServiceLabelId = (appointmentType?: AppointmentType | null): string => {
  switch (appointmentType) {
    case AppointmentType.controlVisit:
      return 'activeAppointmentModal.service.controlVisit';
    case AppointmentType.aec:
      return 'activeAppointmentModal.service.aec';
    default:
      return 'activeAppointmentModal.service.fitting';
  }
};
